import { Injectable, Optional } from '@angular/core';

import { UserService } from '@frontend/sports/user/feature';

import { IBetslipState, defaultBetslipBaseState } from '../../base/store/state';
import { BetslipState } from '../../core/betslip-state';
import { defaultAffiliateState } from '../affiliates/state/affiliate.state';
import { defaultBetslipPlaceBetState, defaultBetslipPlaceButtonState } from '../betplacement/state';
import { defaultHiddenMarketState } from '../hidden-market/hidden-market.state';
import { defaultInfoMessagesState } from '../info-messages/state';
import { defaultLineSwitcherState } from '../line-switcher/state';
import { defaultNotificationState } from '../notifications/state';
import { defaultOddsPreferencePopupState } from '../odds-preference-popup/odds-preference-state.model';
import { BetslipOverAskStateStorageService } from '../over-ask/services/betslip-over-ask-state-storage';
import BetslipPicksStateStorageService from '../picks/services/betslip-picks-state-storage.service';
import { BetslipQuickBetStateStorageService } from '../quick-bet/betslip-quick-bet-state-storage.service';
import { IQuickBetState } from '../quick-bet/quick-bet.state';
import { defaultQuickDepositState } from '../quick-deposit/quick-deposit.state';
import ResultStateStorageService from '../result/services/result-state-storage.service';
import { defaultResultState } from '../result/state';
import { defaultRewardTokensState } from '../reward-tokens/state';
import { RewardTokensStateStorageService } from '../reward-tokens/state-storage';
import SettingsStateStorageService from '../settings/services/settings-state-storage.service';
import { defaultSourcePageState } from '../source-page/source-page.state';
import { defaultTrackingState } from '../tracking/state';
import BetslipTypesStateStorageService from '../types/services/betslip-types-state-storage.service';
import { defaultErrorState } from '../validation/state';
import { IBetslipSavedState } from './betslip-state-model';

@Injectable()
export default class BetslipStateLoaderService {
    constructor(
        private picksStateStorage: BetslipPicksStateStorageService,
        private typesStateStorage: BetslipTypesStateStorageService,
        private resultStateStorage: ResultStateStorageService,
        private settingsStateStorage: SettingsStateStorageService,
        private overAskStateStorage: BetslipOverAskStateStorageService,
        private rewardTokensStateStorage: RewardTokensStateStorageService,
        @Optional() private quickBetStateStorage: BetslipQuickBetStateStorageService | null,
        private user: UserService,
    ) {}

    load(state: IBetslipSavedState | undefined): IBetslipState {
        if (state?.base?.state === BetslipState.Placing || state?.base?.state === BetslipState.Result) {
            state.base = {
                ...state.base,
                state: defaultBetslipBaseState.state,
            };
        }

        return {
            base: state?.base || defaultBetslipBaseState,
            picks: this.picksStateStorage.fromSavedState(state?.picks),
            types: this.typesStateStorage.fromSavedState(state?.types),
            errors: defaultErrorState,
            //Don't restore reward token state if the user isn't logged in
            rewardTokens:
                this.user.isAuthenticated && state?.rewardTokens ? this.rewardTokensStateStorage.load(state.rewardTokens) : defaultRewardTokensState,
            placeBet: state?.placeBet || defaultBetslipPlaceBetState,
            // placeBet: this.betslipPlaceBetStateStorageService.fromSavedState(state?.placeBet),
            result: this.user.isAuthenticated && state?.result ? this.resultStateStorage.fromSavedState(state?.result) : defaultResultState,
            settings: this.settingsStateStorage.fromSavedState(state?.settings),
            placeButton: defaultBetslipPlaceButtonState,
            // placeButton: state?.placeButton ? state.placeButton : defaultBetslipPlaceButtonState,
            overAskState: this.overAskStateStorage.fromSavedState(state?.overAskState),
            lineSwitcher: defaultLineSwitcherState,
            notifications: defaultNotificationState,
            affiliateState: defaultAffiliateState,
            quickBet: this.quickBetStateStorage?.fromSavedState(state?.quickBet) || ({} as never as IQuickBetState),
            quickDeposit: defaultQuickDepositState,
            hiddenMarket: defaultHiddenMarketState,
            oddsPreferencePopupState: state?.oddsPreferencePopupState || defaultOddsPreferencePopupState,
            sourcePageState: defaultSourcePageState,
            infoMessages: defaultInfoMessagesState,
            tracking: defaultTrackingState,
        };
    }
}
